export default "__VITE_ASSET__af62033c__"